/**
 * Function that can be used to handle the response from an API when an array of data is expected.
 * @param response the API response.
 * @returns An empty array if there is no response or the response is not an array. Otherwise returns the response.
 */
export function handleResponseArray<T>(response: unknown): T[] {
  if (!response) {
    return [];
  }
  if (!Array.isArray(response)) {
    return [];
  }
  return response;
}
